/**
 * TibiMedia Customer API
 *
 * Contact: administratie@tibimedia.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Address } from './address';
import { ConsumerOrderLine } from './consumerOrderLine';


export interface ConsumerOrderDetailsOrder { 
    state?: ConsumerOrderDetailsOrderStateEnum;
    address?: Address;
    totalAmount?: number;
    lines?: Array<ConsumerOrderLine>;
}
export enum ConsumerOrderDetailsOrderStateEnum {
    Requested = 'requested',
    Processing = 'processing',
    Delivered = 'delivered'
};



